/**
 * Pre-login password hashing for arcano.app
 * This code is under copyright Arcano Gmbh (https://arcano.app).
 *
 * - no commercial use
 * - no modifications
 * - no redistribution
 *
 * without written consent of Arcano Gmbh, zentralstrasse 47, 8003 zürich, switzerland, https://arcano.app
*/
'use strict';


import {generateScryptHash, getSecretKey} from "./crypto";
import {deleteItem, getIndexedDB, mfetch, setItem, setupPasswordEye, showErrorsOnForm} from "./utils";

function isPlugin() {
    return document.location.href.indexOf('/plugin/') >= 0;
}

/**
 * Hashes the password locally and if possible stores the secret key ion the indexedDB
 */
async function onFormSubmit (formEvent: Event) {
    formEvent.preventDefault();
    const username = document.getElementById('username') as HTMLInputElement;
    const password = document.getElementById('password') as HTMLInputElement;

    if (password.value && username.value) {

        const button = document.getElementById('submit_button') as HTMLButtonElement
        const initialText = button.innerHTML
        button.innerHTML = 'Securing login <img src="/img/icons/oval.svg" alt="Verified" height="16">'  // note: save innerHtml
        button.disabled = true
        username.readOnly = true
        password.readOnly = true

        mfetch('/pre_login/' + username.value).then((response) => response.json()).then(result => {

            let passwordData = new TextEncoder().encode(password.value);
            generateScryptHash(passwordData, result.hkdfSalt, result.scryptSalt).then(async (hash) => {

                let hashedPassword = await crypto.subtle.digest('SHA-256', new TextEncoder().encode('This is just an exercice, we use scrypt now'));
                if(!result.hkdfSalt || !result.scryptSalt) {
                    hashedPassword = await crypto.subtle.digest('SHA-256', passwordData);
                }

                let data = new FormData((formEvent.target as HTMLFormElement));
                data.set('password', (new Uint8Array(hashedPassword).toString()));
                data.set('hkdf_salt', hash.hkdfSaltHex);
                data.set('scrypt_salt', hash.scryptSaltHex);
                data.set('scrypt_hashed_password', hash.scryptHashedPassword);

                const url = new URL((formEvent.target as HTMLFormElement).action);
                let urlString = url.pathname + url.search;
                if(isPlugin() && urlString.indexOf('/login') < 0) {
                   urlString = url.pathname + '/login' + url.search;
                }
                let request = await mfetch(urlString, {
                    method: 'POST',
                    body: data
                }) as any;
                let response: string = '/';
                try {
                    response = await request.text();
                } catch (e) {
                    console.log('Could not process response')
                    // response = "{}"
                }

                if(request.status === 200) {
                    if(!response) {
                        response = "/"
                    }
                    try {
                        const unwrappedKey = await getSecretKey(password.value)
                        const dbsuccess = (event: any) => {
                            const onerror = () => {
                                window.location.href = '/';
                            }
                            const oncomplete = () => {
                                if(isPlugin()) {
                                    // if(document.location.origin + '/'  === response) { // special case if 2FA
                                    //     document.location.href = response + 'plugin';
                                    // }
                                    // if(document.location.origin + '/de/'  === response) { // special case if 2FA
                                    //     document.location.href = response + 'plugin';
                                    // }
                                    // if(document.location.origin + '/'  === response) { // special case if 2FA
                                    document.location.href = response + 'plugin';
                                    // }
                                } else{
                                    window.location.href = response;
                                }
                            }

                            let db = event.target.result;
                            setItem(db, 'key', unwrappedKey, oncomplete, onerror);
                        }
                        const dbfail = (event: any) => {
                            // ok we have no indexedDB, it should not matter...
                            console.log(event);
                            window.location.href = response;  // get logged in anyway
                        }
                        getIndexedDB(dbsuccess, dbfail);
                    } catch (err) {
                        // pass
                    }
                } else {
                    if(!response) {
                        response = "{}"
                    }
                    button.innerHTML = initialText;  // note: save innerHtml
                    button.disabled = false
                    username.readOnly = false
                    password.readOnly = false
                    if(request.status === 400) {
                        showErrorsOnForm(response)
                    }
                    if(request.status === 401) {
                        showErrorsOnForm(response)
                        // ("Invalid user or password or 2FA (if enabled)", 'info')
                    }
                    if(request.status === 403) {
                        document.getElementById("second-factor-row")!.style.display = 'block';
                        const twoFA = document.getElementById('has2fa') as HTMLInputElement;
                        twoFA.value = "1";
                        document.getElementById('secondfactor')!.focus();
                    }
                }
            })
        })
    }
}




export function setupLogin() {
    const form = document.getElementById('loginForm');
    if(!form) {
        return
    }
    setupPasswordEye()


    form.addEventListener('submit', onFormSubmit);

    // lets clean the cookies and indexedDB
    let db;
    let dbReq = indexedDB.open('arcano.app', 1);
    dbReq.onupgradeneeded = (event) => {
        // Set the db variable to our database so we can use it!
        // noinspection JSUnresolvedVariable
        // @ts-ignore
        db = event.target.result;
    }
    dbReq.onsuccess = function (event) {
        // noinspection JSUnresolvedVariable
        db = (event.target as IDBOpenDBRequest).result;
        deleteItem(db, 'key', () => {}, () => {})
    }
    dbReq.onerror = function () {

    }

    navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for(let registration of registrations) {
            // noinspection JSIgnoredPromiseFromCall
            registration.unregister()
        }
    })
    function deleteAllCookies() {
        const cookies = document.cookie.split(";");

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            if(name !== 'analytics') {
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
        }
    }
    deleteAllCookies()
}
